export interface ExpenseConceptFormModel {
  nameEn: string;
  nameEs: string;
  isActive: boolean;
}

export const expenseConceptFieldLabels: Record<keyof ExpenseConceptFormModel, string> = {
  nameEn: 'ExpenseConcept_Details_Form_Field_NameEn',
  nameEs: 'ExpenseConcept_Details_Form_Field_NameEs',
  isActive: 'ExpenseConcept_Details_Form_Field_IsActive',
};
